import { render, staticRenderFns } from "./HistoryServerList.vue?vue&type=template&id=29f73d2c&scoped=true"
import script from "./HistoryServerList.vue?vue&type=script&lang=js"
export * from "./HistoryServerList.vue?vue&type=script&lang=js"
import style0 from "./HistoryServerList.vue?vue&type=style&index=0&id=29f73d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f73d2c",
  null
  
)

export default component.exports